import React, {useState, useEffect} from 'react';
import Disclaimer from '../components/Disclaimer';
import {autoScrollByElemento, KEYCODE_ENTER} from '../components/Utilitario';
import '../css/basics/Textfield.css';

function TextFieldBbva(props) {
  const {
    onBlur,
    onChange,
    disablePaste,
    id,
    name,
    label,
    error,
    disabled,
    readonly,
    required,
    value,
    inputmode,
    mensajeDisclaimer,
    typeInput = 'text',
    placeholder,
    activeEnter = false,
    dataError,
    onClickProp,
    onFocus,
    cssValueInfo,
    cssIcon,
    ambient = 'primary',
    minHeigth = '',
    maxLength = 100,
    dataValidacion,
    dataTipoDato,
    dataFormato,
    dataTipoPregunta,
    orden,
    cssColorBackGround,
  } = props;
  const [stateHolder, setStateholder] = useState(placeholder);
  const [inElemento, setInElemento] = useState(false);
  const [textValue, setTextValue] = useState(value || '');

  useEffect(() => {
    setTextValue(value);
  }, [value]);

  function onKeyUp(event) {
    let {keyCode} = event;
    if (keyCode === KEYCODE_ENTER && activeEnter) eventOnBlur();
  }

  function eventOnBlur(event) {
    if (onBlur) {
      onBlur(event);
    }
    setStateholder(' ');
    setInElemento(false);
  }

  function eventOnChange(event) {
    setInElemento(true);
    onChange(event);
  }

  function handlerCopy(e) {
    if (disablePaste === true) {
      e.preventDefault();
    }
  }

  function onClick(event) {
    autoScrollByElemento(event);
    if (typeInput === 'date') {
      setStateholder('DD/MM/AAAA');
    };
    if(onClickProp) {
      onClickProp(event);
    };
  }

  function clearClick() {
    setTextValue('');
    const event = {
      target: {
        value: '',
        name: name,
        id: id,
        getAttribute: (attr) => {
          switch (attr) {
            case 'data-error': return dataError;
            case 'data-validacion': return dataValidacion;
            case 'data-tipodato': return dataTipoDato;
            case 'data-formato': return dataFormato;
            case 'data-tipopregunta': return dataTipoPregunta;
            case 'data-orden': return orden;
            default: return null;
          }
        }
      },
      bubbles: true,
      cancelable: true
    };
    eventOnChange(event);
  }

  let className = cssColorBackGround ? [`bbva-input bg-sphericaSecondary`] : [`bbva-input textfield-emprendedor bg-sphericaSecondary`];
  if (disabled) {
    className.push('input--disabled');
  } else if (error) {
    className.push('input--error');
  }

  const inputProps = {
    id: id,
    name: name,
    placeholder: stateHolder ? stateHolder : ' ',
    className: className.join(' '),
    onPaste: handlerCopy,
    inputMode: inputmode,
    onChange: eventOnChange,
    onBlur: eventOnBlur,
    onClick: onClick,
    onKeyUp: onKeyUp,
    onFocus: onFocus,
    value: textValue,
    disabled: disabled,
    readOnly: readonly,
    required: required,
    maxLength: maxLength,
/*     autoComplete: 'off', */
    type: 'text',
    'data-error': dataError,
    'data-validacion': dataValidacion,
    'data-tipodato': dataTipoDato,
    'data-formato': dataFormato,
    'data-tipopregunta': dataTipoPregunta,
    'data-orden': orden,
  };
  let inputHTML = (
      <React.Fragment><input {...inputProps} />
    {textValue ? (
      <span
        style={{ color: error ? 'var(--color-dark-red)' : 'var(--color-dark-blue)' }}
        onClick={clearClick}
      >
        &#x2715;
        </span>
          ) : (
            ''
          )}
        </React.Fragment>
        );
  
  return (
    <div className={`flex flex-col relative ${minHeigth}`}>
      <span className="deleteicon">
          {inputHTML}
          <label htmlFor={id} className="bbva-input-label">
            {label}
          </label>
      </span>

      <div className='w-full'>
        <Disclaimer
          css={cssValueInfo}
          cssIcon={cssIcon}
          mensaje={mensajeDisclaimer && error === '' ? mensajeDisclaimer : error} error={error !== ''}
        />
      </div>
    </div>
  );
}

export default TextFieldBbva;
